<script>
import { updateEssay, getClasses } from "@/api";

export default {
  name: "MoveEssayModal",
  props: {
    essayId: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      loading: true,
      selectedClass: null,
      classOptions: [],
    };
  },
  methods: {
    async moveEssay() {
      try {
        this.loading = true;

        const { data } = await updateEssay(this.essayId, {
          ClassId: this.selectedClass,
        });

        this.essay = data;

        this.loading = false;
        this.error = "";

        this.$emit("essayMoved");
      } catch (error) {
        this.loading = false;
        this.$emit("moveError", error.response?.data?.error);
      }
    },
    async fetchClasses() {
      // safeguard to ensure we don't fetch for classes
      // more than once.
      if (this.classOptions.length === 0) {
        try {
          const { data } = await getClasses();

          data.classes.forEach((foundClass) => {
            this.classOptions.push({
              text: foundClass.name,
              value: foundClass.id,
            });
          });

          this.loading = false;
          this.error = "";
        } catch (error) {
          this.loading = false;
          this.error = error.response?.data?.error;
        }
      }
    },
  },
};
</script>

<template>
  <eg-b-modal
    id="move-essay-modal"
    :title="$t('essays.moveEssay')"
    :ok-title="$t('common.move')"
    ok-variant="info"
    size="lg"
    @show="fetchClasses"
    @ok="moveEssay"
  >
    <eg-b-spinner v-if="loading"></eg-b-spinner>
    <div v-else>
      <p v-if="!classOptions.length">{{ $t("common.noClassesFound") }}</p>
      <eg-b-form-group
        id="class-select"
        :description="$t('essays.onlyLast15Classes')"
        :label="$t('essays.selectClassToMove')"
        label-for="class-form-select"
      >
        <eg-b-form-select
          id="class-form-select"
          v-model="selectedClass"
          :options="classOptions"
        ></eg-b-form-select>
      </eg-b-form-group>
    </div>
  </eg-b-modal>
</template>
